<template>
    <div :class="[
            'card-slider',
            { 'card-slider--with-image' : withImage }
        ]"
    >
        <div
            v-if="this.$slots['title']"
            class="card-slider__header"
        >
            <slot name="title"/>
        </div>
        <div class="swiper-container" ref="slider">
            <div class="swiper-wrapper">
                <slot name="slides" />
            </div>
            <div class="card-slider__controls">
                <div class="card-slider__artline" v-if="artline"></div>
                <div class="card-slider__nav-btns">
                    <button class="card-slider__btn card-slider__btn--prev">
                        <z-icon
                            name="modal-arrow"
                            width="24"
                            height="24"
                        />
                    </button>
                    <button class="card-slider__btn card-slider__btn--next">
                        <z-icon
                            name="modal-arrow"
                            width="24"
                            height="24"
                        />
                    </button>
                </div>
                <div class="card-slider__pagination"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'

export default {
    name: 'card-slider',
    props: {
        withImage: {
            type: Boolean,
            default: false
        },
        artline: {
            type: Boolean,
            default: true
        },
        artlineColor: {
            type: String,
            default: ''
        },
        autoHeight: Boolean
    },
    methods: {
        initSlider () {
            const options = {
                observer: true,
                simulateTouch: false,
                observeParents: true,
                autoHeight: this.autoHeight,
                fadeEffect: {
                    crossFade: true
                },
                effect: 'fade',
                slidersPerView: 1,
                navigation: {
                    disabledClass: 'is-disabled',
                    nextEl: '.card-slider__btn--next',
                    prevEl: '.card-slider__btn--prev'
                },
                pagination: {
                    clickable: true,
                    el: '.card-slider__pagination'
                }
            }

            this.slider = new Swiper(this.$refs.slider, options)
        },
        setImageState () {
            this.withImage = true
        }
    },
    mounted () {
        this.initSlider()
    }
}
</script>

<style lang="scss">
.card-slider {
    position: relative;
    border: 1px solid $token-colors-black-10;

    &__header {
        padding: $token-spacers-l $token-spacers-l 0;
    }

    &__controls {
        position: static;
        margin-top: -$token-spacers-m;
        padding: $token-spacers-m $token-spacers-l;
    }

    &__nav-btns {
        font-size: 0;
        position: absolute;
        right: 32px;
        padding: $token-spacers-m 0;
        bottom: 0;

        .z-icon {
            path {
                fill: $token-colors-black-60;
            }
        }
    }

    &__btn {
        background: none;
        padding: 0;
        border: none;
        outline: none;
        cursor: pointer;
        transition: transform 0.1s linear;

        &.is-disabled {
            opacity: 0.4;
            pointer-events: none;
        }

        &--next {
            .z-icon {
                transform: scale(-1, 1);
            }

            &:hover {
                transform: translateX(2px);
            }
        }

        &--prev {
            &:hover {
                transform: translateX(-2px);
            }
        }
    }

    &__pagination {
        margin-left: -$token-spacers-xs;
        margin-right: -$token-spacers-xs;
        text-align: center;
        padding: 0 $token-spacers-xxl;

        .swiper-pagination-bullet {
            background: rgba($token-colors-white, 0.4);
            border: 1px solid #E42213;
            margin: 0 $token-spacers-xs;
            width: 6px;
            height: 6px;
            outline: none;
            cursor: pointer;
            opacity: 1;

            &-active {
                background: #E42213;
            }
        }
    }

    &__artline {
        position: absolute;
        top: $token-spacers-xxxl;
        right: -1px;
        width: 12px;
        height: 12px;
        background-color: #E42213;
        z-index: 3;

        &::before,
        &::after {
            content: '';
            position: absolute;
            width: 12px;
            height: 12px;
        }

        &::before {
            background-color: #EE7918;
            top: -12px;
        }

        &::after {
            background-color: #FBB92F;
            top: -24px;
        }
    }
}

.card-slider--with-image {
    .card-slider {
        &__controls {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 2;
            padding: 0;
            margin: 0;
            padding-top: 57%;
        }

        &__artline {
            top: calc(100% + #{$token-spacers-xxxl});
        }

        &__nav-btns {
            top: auto;
            transform: none;
            bottom: $token-spacers-s + 3;
            right: 12px;
            padding: 0;

            .z-icon {
                path {
                    fill: $token-colors-white;
                }
            }
        }

        &__pagination {
            position: absolute;
            bottom: $token-spacers-s;
            left: 50%;
            transform: translateX(-50%);

            .swiper-pagination-bullet {
                background: rgba($token-colors-white, 0.4);
                border: none;

                &-active {
                    background: #E42213;
                }
            }
        }
    }
}
</style>
